import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/global.css */
  .user_tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 1;
  }
  .user_tabs_wrapper .user_panels {
    width: 100%;
  }
  .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }
  .content.column:nth-child(1) {
    width: 100%;
    align-items: center;
    border-top: 0;
  }
  .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content label {
    padding: 0 0 10px 0;
    line-height: 130%;
    display: flex;
    align-items: center;
  }
  .grid-content label.title {
    text-align: right;
    text-transform: uppercase;
    font-size: 0.8rem;
    justify-content: flex-end;
    max-width: 300px;
  }
  .grid-content label.value {
    margin: 0 0 0 15px;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
`

const developerCSS = css``

export const OtherUserPanelCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
